// This file runs BEFORE main.js to set up globals needed by dependencies
import VueCompositionAPI from '@vue/composition-api';
import * as VueCompositionAPIAll from '@vue/composition-api';
import Vue from 'vue';

// CRITICAL: Install the composition API plugin FIRST
Vue.use(VueCompositionAPI);

// Set globals that kpi-tracker will look for
window.__VUE_INSTANCE__ = Vue;
window.__VUE_COMPOSITION_API_INSTANCE__ = VueCompositionAPIAll;

console.log('[entry.js] Set window globals BEFORE main.js:', {
  hasVue: !!window.__VUE_INSTANCE__,
  hasCompositionApi: !!window.__VUE_COMPOSITION_API_INSTANCE__,
  hasRef: !!(window.__VUE_COMPOSITION_API_INSTANCE__ && window.__VUE_COMPOSITION_API_INSTANCE__.ref),
  refType: window.__VUE_COMPOSITION_API_INSTANCE__ && typeof window.__VUE_COMPOSITION_API_INSTANCE__.ref,
  hasDefault: !!VueCompositionAPI,
  defaultIsInstall: typeof VueCompositionAPI?.install
});

// Now import and run main
import('./main.js');
